import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../auth/AuthProvider.jsx";
import { getRoles, roleLabel } from "../../auth/roles.js";

export default function RekoDashboard() {
    const { user } = useAuth();

    const displayName =
        user?.display_name ||
        user?.discord_username ||
        user?.email ||
        "ReKo";

    const roles = getRoles(user).map(roleLabel).join(", ");

    return (
        <div className="card">
            <h1>ReKo Bereich</h1>

            <p className="muted">
                Willkommen, {displayName}. Hier entsteht später der Bereich für Proteste, Sichtungen und Entscheidungen.
            </p>

            <div style={{ marginTop: 12, opacity: 0.85 }}>
                <strong>Aktive Rollen:</strong> {roles || "keine Rollen gefunden"}
            </div>

            <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginTop: 18 }}>
                <Link className="btn" to="/manager/reko/incidents">
                    Incidents öffnen
                </Link>
            </div>

            <div className="alert alert--ok" style={{ marginTop: 16 }}>
                Platzhalter: Wenn du diese Seite siehst, funktioniert die Rolle <strong>reko</strong>.
            </div>
        </div>
    );
}